import { Result, useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { RoleViewModel } from "../Roles.types";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { IChangeRoleStatusDialog } from "./ChangeRoleStatusDialog";
import { put } from "@common/api/apiShared";

export function useChangeRoleStatusDialog(props: IChangeRoleStatusDialog) {
    const snackbar = useDotLegalSnackbar();

    const changeActiveStatusMutation = useDotLegalMutation(changeStatus);

    const changeActiveStatus = () => {
        changeActiveStatusMutation.mutateAsync(props.selectedRole, {
            onSuccess: (response: any) => {
                props.onCloseDialog();
                if (response.success()) {
                    snackbar.show(
                        createElement(Trans, {
                            i18nKey: props.selectedRole.isActive ? "roleDeactivated" : "roleActivated",
                            values: { name: props.selectedRole.name },
                        })
                    );
                    props.onSave();
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "roleStatusNotChanged", values: { name: props.selectedRole.name } }), "warning");
                }
            },
        });
    };

    function changeStatus(role: RoleViewModel) {
        if (role.isActive) {
            return put(`/roles/${role.id}/deactivate`, null);
        }

        return put(`/roles/${role.id}/activate`, null);
    }

    return {
        changeActiveStatus,
        inProgress: changeActiveStatusMutation.isLoading,
    };
}
